import { DeprecatedCloseIcon as Close, DeprecatedDoneIcon as Done } from '@lokalise/louis';
import { useTheme } from '@lokalise/styled';
import type { FC, ReactNode } from 'react';

import { PolicyItemIcon, PolicyItemWrapper } from '../components';

interface PolicyItemProps {
    passed: boolean;
    children: ReactNode;
}

const PolicyItem: FC<PolicyItemProps> = ({ passed, children }) => {
    const theme = useTheme();

    return (
        <PolicyItemWrapper>
            <PolicyItemIcon>
                {passed ? (
                    <Done ariaLabel="Validation requirement passed:" color={theme.color.text.success} />
                ) : (
                    <Close ariaLabel="Validation requirement not passed:" color={theme.color.text.danger} />
                )}
            </PolicyItemIcon>
            {children}
        </PolicyItemWrapper>
    );
};

export default PolicyItem;
